import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTypeAction, UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function PendingApprovalButtonI18nTitleNonParticipant(props) {
  const {
    approvalType,
    approvalAction
  } = props;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.MARKETING_EMAIL-PUBLISH.NON_PARTICIPANT"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.LANDING_PAGE-PUBLISH.NON_PARTICIPANT"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.SITE_PAGE-PUBLISH.NON_PARTICIPANT"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.BLOG_POST-PUBLISH.NON_PARTICIPANT"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.DEAL-MOVE_STAGE.NON_PARTICIPANT"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipTitle.body.KNOWLEDGE_ARTICLE-PUBLISH.NON_PARTICIPANT"
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}
export default PendingApprovalButtonI18nTitleNonParticipant;